import { Box, Icon, Switch } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useContext, useEffect, useState } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { AuthContext } from '../../../shared/context/AuthContext';
import C from '../../../../../shared/constants/general';
import queryString from 'query-string';
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.shadedown_20,
  },
  eventItem: {
    flexGrow: '1',
    display: 'flex',
    flexDirection: 'row',
    border: '0px solid #ff0000',
    margin: '0px',
    minHeight: '50px',
    padding: '10px',
    cursor: 'pointer',
  },
  eventItemSelected: {
    backgroundColor: theme.palette.background.shadedown_10,
    //backgroundColor: '#ff0000',
  },
  eventItemDontShow: {
    opacity: '0.2',
    pointerEvents: 'text',
    //backgroundColor: '#ff0000',
  },
  infoContainer: {
    flexGrow: '1',
    display: 'flex',
    marginLeft: '10px',
    flexDirection: 'column',
  },
  thumbnailContainer: {
    minWidth: '90px',
    borderWidth: '1px',
    borderStyle: 'solid',
    backgroundColor: '#000',
    borderColor: theme.palette.primary.main,
    display: 'flex',
    borderRadius: '5px',
    maxHeight: '50px',
    minHeight: '50px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    color: '#fff',
    opacity: 0.9,
    /*alignSelf: 'center',*/
    '&:hover': {
      opacity: 1,
    },
  },
  infoTitle: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  infoSubTitle: {
    fontSize: 12,
  },
  editMode: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  counter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '10px',
  },
  infoEdit: {
    fontSize: 14,
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
}));

function truncate(source, size) {
  return source.length > size ? source.slice(0, size - 1) + '…' : source;
}

const EventNavigation = withRouter((props) => {
  const classes = useStyles();
  const { authState } = useContext(AuthContext);
  const { eventId } = useParams();
  const qs = queryString.parse(props.location.search);
  const [editMode, setEditMode] = useState(false);
  const [editEventId, setEditEventId] = useState(null);

  const handleEditMode = (event) => {
    setEditMode(event.target.checked);
    if (!event.target.checked) {
      window.history.pushState(null, null, window.location.pathname);
      location.reload();
    } else {
      setEditEventId(eventId);
      props.history.push(`${props.history.location.pathname}?edit=true`);
    }
  };

  const isModerator =
    authState.user &&
    authState.user.access_level === C.VISITOR.ACCESS_LEVEL.MODERATOR;

  const gotoEvent = (eventId) => {
    props.goToEventCallback(eventId);
    let qstring = '';
    if (isModerator) {
      if (editMode) {
        qstring = '?edit=true';
        setEditEventId(eventId);
      } else {
        qstring = '';
      }
    }
    props.history.push(`/live/session/${eventId}${qstring}`);
  };

  const pluralize = (count, noun, suffix = 's') =>
    `${count} ${noun}${count !== 1 ? suffix : ''}`;

  useEffect(() => {
    if (qs.edit) {
      setEditMode(true);
      setEditEventId(eventId);
    } else {
      setEditMode(false);
    }
  }, [qs.edit]);

  return (
    <Box className={classes.root}>
      {isModerator && (
        <>
          <div className={classes.editMode}>
            <Switch
              checked={editMode}
              onChange={handleEditMode}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            {'Edit Mode'}
          </div>
          <div className={classes.counter}>
            This replay contains {pluralize(props.assetCount, 'video asset')}
          </div>
        </>
      )}
      {props.events.map((event, index) => {
        let backgroundImage_url = '';
        let selectedClass = '';
        let typeClass = '';

        if (event.start_asset) {
          if (event.start_asset.start_offest_seconds < 0) {
            event.start_asset.start_offest_seconds = 0;
          }
          backgroundImage_url = `url(/api/redirect_mux_image/${event.start_asset.mux_asset_playback_id}/thumb/${event.start_asset.start_offest_seconds})`;
        }
        //Event have "do not show" set in admin
        if (event.type !== C.EVENT.TYPE.HAS_VIDEO) {
          typeClass = classes.eventItemDontShow;
        }
        //Event is the one selected
        if (!editMode) {
          if (event.id === props.selectedEvent.id) {
            selectedClass = classes.eventItemSelected;
          }
        } else {
          if (event.id === editEventId) {
            selectedClass = classes.eventItemSelected;
          }
        }

        return (
          <div
            className={`${classes.eventItem} ${selectedClass} ${typeClass}`}
            key={index}
            onClick={() =>
              typeClass && qs.edit
                ? null
                : event.id !== eventId
                ? gotoEvent(event.id)
                : null
            }
          >
            <div className={`${classes.eventItem}`}>
              <div
                className={classes.thumbnailContainer}
                style={{
                  backgroundImage: backgroundImage_url,
                }}
              >
                {event.start_asset && !event.start_asset.mux_asset_playback_id && (
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon>play_arrow</Icon>
                    <Box>
                      <strong>Replay</strong>
                    </Box>
                  </Box>
                )}
              </div>
              <div className={classes.infoContainer}>
                <div className={classes.infoTitle}>
                  {editMode && (
                    <span className={classes.infoEdit}>[Edit] </span>
                  )}
                  {truncate(event.title, 50)}
                </div>
                <div className={classes.infoSubTitle}>
                  {truncate(event.description, 60)}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </Box>
  );
});

export default EventNavigation;
